const getImageUrl = (imageId: string) => {
  return `https://res.cloudinary.com/peerspace-inc/image/upload/q_auto,g_auto,f_auto,w_560,h_448,c_fill/${imageId}`;
};

export { getImageUrl };
